// extracted by mini-css-extract-plugin
export var centerText = "_4g-8";
export var container = "_4g-0";
export var doughnutContainer = "_4g-7";
export var legend = "_4g-a";
export var legendItemColorDisplay = "_4g-b";
export var legendItemLabel = "_4g-d";
export var legendItemValue = "_4g-c";
export var lg = "_4g-5";
export var maxWidth = "_4g-9";
export var md = "_4g-4";
export var responsive = "_4g-6";
export var sm = "_4g-3";
export var xs = "_4g-2";
export var xxs = "_4g-1";